import React from "react";
import { Pie } from "@ant-design/charts";
import { Skeleton } from "@pankod/refine-antd";
import { useCustom } from "@pankod/refine-core";
import ENV from "utils/env";
import { extractArray } from "../utils";

interface EventDistributionPieProps {
  dateRange: [string, string];
  shopCode: string | null;
}

export const EventDistributionPie: React.FC<EventDistributionPieProps> = ({
  dateRange,
  shopCode,
}) => {
  const { data: response, isFetching } = useCustom({
    url: `${ENV.API_URL}/api/analytics/stats/event-distribution`,
    method: "get",
    config: {
      query: {
        startDate: dateRange[0],
        endDate: dateRange[1],
        ...(shopCode ? { shopCode } : {}),
      },
    },
    queryOptions: { retry: 0 },
  });

  if (isFetching) return <Skeleton active />;

  const raw = extractArray<{ label: string; count: string }>(response?.data);
  const data = raw.map((r) => ({
    type: r.label,
    value: parseInt(r.count, 10),
  }));

  if (data.length === 0) {
    return (
      <span style={{ color: "#8c8c8c" }}>Bu filtrelere ait veri bulunamadı.</span>
    );
  }

  const config = {
    data,
    angleField: "value",
    colorField: "type",
    paddingRight: 80,
    label: {
      text: "value",
      position: "outside" as const,
    },
    legend: {
      color: {
        title: true,
        position: "left" as const,
        rowPadding: 0,
      },
    },
  };

  return <Pie {...config} />;
};
